module.exports = __webpack_public_path__ + "./Daniel2_666cd3ab08ae9fe17287625b8f913eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Daniel2.png
// module id = 549
// module chunks = 0